module.exports = __webpack_public_path__ + "f1bb9678881de23c4b247f71902afc6d.png";